import axios from 'axios';

// Configure your API base URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add interceptors for auth token if needed
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Generic CRUD operations for any model
export const apiService = {
  // ===== META ENDPOINTS (NEW) =====
  
  /**
   * Get list of available models from the API
   * Endpoint: GET /api/v1/_meta/models
   */
  getModels: async () => {
    try {
      const response = await api.get('/_meta/models');
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  /**
   * Get JSON schema for a specific model from the API
   * Endpoint: GET /api/v1/_meta/schema/:modelName
   */
  getSchema: async (modelName) => {
    try {
      const response = await api.get(`/_meta/schema/${modelName}`);
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  // ===== CRUD ENDPOINTS =====

  // Get all documents for a model
  getAll: async (modelName, params = {}) => {
    try {
      const response = await api.get(`/${modelName}`, { params });
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  // Get single document by ID
  getById: async (modelName, id) => {
    try {
      const response = await api.get(`/${modelName}/${id}`);
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  // Create new document
  create: async (modelName, data) => {
    try {
      const response = await api.post(`/${modelName}`, data);
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  // Update document by ID
  update: async (modelName, id, data) => {
    try {
      const response = await api.put(`/${modelName}/${id}`, data);
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  // Delete document by ID
  delete: async (modelName, id) => {
    try {
      const response = await api.delete(`/${modelName}/${id}`);
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  // Get referenced documents (for populating dropdowns)
  getReferences: async (refModel) => {
    try {
      const response = await api.get(`/${refModel}`);
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  }
};

// Error handler
const handleError = (error) => {
  if (error.response) {
    // Server responded with error
    return {
      message: error.response.data.message || 'An error occurred',
      status: error.response.status,
      data: error.response.data
    };
  } else if (error.request) {
    // Request made but no response
    return {
      message: 'No response from server. Is the API running?',
      status: 0
    };
  } else {
    // Something else went wrong
    return {
      message: error.message || 'An unexpected error occurred',
      status: -1
    };
  }
};

export default apiService;
